<template>
    <a-card type="inner" size="small" >
        <a-skeleton :loading="loading" active>
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items"
                rowKey="hash"
                :pagination="false"
                bordered>

                <div slot="photo" slot-scope="record" style="text-align: center">
                    <a-avatar :src="record.photo" shape="square" :size="64" icon="user" />
                </div>

                <div slot="name" slot-scope="record" style="text-align: left">
                    <h4>
                        <a-icon type="user" /> {{ record.name }} <br />
                        <a :href="`tel:${record.mobile_phone}`"><a-icon type="phone" /></a> {{ record.mobile_phone }}
                    </h4>
                </div>

                <div slot="branch" slot-scope="record" class="text-left">
                    <h4>
                        <a-icon type="bank" /> {{ record.members[0].position.branch.name }} <br />
                        <a-icon type="team" /> {{ record.members[0].position.name }}
                    </h4>
                </div>

                <div slot="majors" slot-scope="record" class="text-left">
                    <h4>
                        <a-icon type="experiment" /> {{ record.majors }} <br />
                        <a-icon type="bank" /> {{ record.university }}
                    </h4>
                </div>

                <div slot="count" slot-scope="record" class="text-center">
                    <a-badge :count="record.observations.length" :number-style="{ backgroundColor: '#52c41a' }" />
                </div>

                <div slot="action" slot-scope="record" style="text-align: center">
                    <a-tooltip title="Observasi">
                        <a-button size="small" icon="eye" @click="() => drawer = { visible: true, user: record.hash, observation: record.observations.length > 0 ? record.observations[0].hash : ''}" />
                    </a-tooltip>

                    <a-tooltip title="Rekap">
                        <a-button size="small" icon="search" :href="routeUri('admin.performance.mentoring.observation.show', {user: record.hash })" />
                    </a-tooltip>
                </div>
            </a-table>
        </a-skeleton>

        <a-drawer :destroyOnClose="true" :width="720" placement="right" :closable="true" :visible="drawer.visible" @close="() => drawer = {visible: false, user: '', observation: '' }">
            <performance-observation-form :user_hash="drawer.user" @handleClose="handleClose" />
        </a-drawer>
    </a-card>
</template>

<script>

const columns = [
    {
		key: 'photo',
		title: 'Foto',
        align: 'center',
        width: 65,
		scopedSlots: {customRender: 'photo'},
	}, {
		key: 'name',
		title: 'Nama Lengkap',
        align: 'center',
		scopedSlots: {customRender: 'name'}
	}, {
        key: 'branch',
        title: 'Cabang',
        align: 'center',
        scopedSlots: {customRender: 'branch'},
    }, {
		key: 'majors',
		title: 'Jurusan - Universitas',
        align: 'center',
		scopedSlots: {customRender: 'majors'}
	}, {
        key: 'count',
        title: 'Observasi',
        align: 'center',
        width: 100,
        scopedSlots: {customRender: 'count'}
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
        width: 100,
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    props: {
        modul: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            drawer: {
                visible: false,
                user: '',
                observation: '',
            },
            columns,
            loading: false,
            items: {},
            filters: {
                q: null
            }
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.performance.observation'), {
                    params: this.filters
                })
                .then(response => this.items = response.data.attendants)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleClose(isRefresh){
            if(isRefresh)
                window.location.reload()
        }
    },
}
</script>
